export const LumiIcon = ({ width = 40, height = 40 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.355263"
        y="0.355263"
        width="39.2895"
        height="39.2895"
        rx="3.64474"
        fill="white"
      />
      <rect
        x="0.355263"
        y="0.355263"
        width="39.2895"
        height="39.2895"
        rx="3.64474"
        stroke="#7647EE"
        strokeWidth="0.710526"
      />
      <path
        d="M20.8229 20.824L15.7559 21.1768L15.5467 18.3793L12.8548 21.379L9.2714 21.6286L9.01262 18.1736L11.7045 15.1739L8.8034 15.3756L8.4375 10.4887L19.9895 9.68454L20.8229 20.824ZM17.1775 19.5917L19.1801 19.4522L18.5675 11.2696L10.0803 11.8604L10.2249 13.7906L15.2944 13.4377L10.5908 18.6785L10.6929 20.043L12.1085 19.9445L16.8116 14.7033L17.1775 19.5917Z"
        fill="#FF5500"
      />
      <path
        d="M31.5651 29.7861L26.4981 30.139L26.2889 27.3414L23.597 30.3412L20.0136 30.5907L19.7548 27.1358L22.4467 24.136L19.5456 24.3378L19.1797 19.4513L30.7317 18.6472L31.5651 29.7861ZM27.9191 28.5539L29.9218 28.4144L29.3091 20.2318L20.822 20.8226L20.9666 22.7527L26.0361 22.3999L21.3325 27.6407L21.4346 29.0052L22.8502 28.9067L27.5532 23.6655L27.9191 28.5539Z"
        fill="#FF5500"
      />
      <path
        d="M18.6984 33.654L13.6314 34.0068L13.4222 31.2093L10.7303 34.2091L7.1469 34.4586L6.88812 31.0037L9.58003 28.0039L6.6789 28.2057L6.3125 23.3192L17.8645 22.5151L18.6984 33.654ZM15.0524 32.4218L17.0551 32.2823L16.4425 24.0997L7.95528 24.6904L8.09993 26.6206L13.1694 26.2678L8.46583 31.509L8.56794 32.8735L9.98347 32.7751L14.6866 27.5338L15.0524 32.4218Z"
        fill="#F7AD3C"
      />
      <path
        d="M33.6823 16.9561L28.6153 17.309L28.4061 14.5114L25.7142 17.5112L22.1308 17.7602L21.872 14.3053L24.5639 11.3056L21.6628 11.5073L21.2969 6.62083L32.8484 5.81671L33.6823 16.9561ZM30.0368 15.7239L32.0395 15.5844L31.4268 7.40178L22.9397 7.99256L23.0843 9.92274L28.1538 9.56991L23.4507 14.8112L23.5528 16.1757L24.9683 16.0772L29.6714 10.8359L30.0368 15.7239Z"
        fill="#F7AD3C"
      />
    </svg>
  );
};
